import { MouseEvent } from 'react';
import useCheckIsMobile from '@/lib/hooks/useCheckIsMobile';
import Link from 'next/link';
import Container from '@/components/Container';
import useRandomAd from '@/lib/hooks/anonymous-instagram-story-viewer/useRandomAd';
import { MoveRight } from 'lucide-react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { ga_logEvent } from '@/shared/ga';

export default function BannerAd() {
  const { isMobile } = useCheckIsMobile();
  const currentAd = useRandomAd();
  const { t } = useTranslation();
  const router = useRouter();

  function linkClick(e: MouseEvent) {
    e.preventDefault();
    ga_logEvent(currentAd.gaLabel);
    setTimeout(() => {
      router.push(currentAd.link);
    }, 100);
  }

  if (!currentAd) return null;

  return (
    <Container
      isFeedback={isMobile}
      feedback={
        <div
          className="mt-10 bg-cover bg-no-repeat aspect-[343/146]"
          style={{ backgroundImage: `url(${currentAd.imgUrl_mb})` }}
        >
          <div className="h-full flex flex-col justify-between px-4 xs:px-8 py-[18px] xs:py-8">
            <h3 className="text-base xs:text-3xl font-bold leading-[1.4] text-white">{currentAd.title}</h3>
            <p className="text-white text-xs xs:text-base">{currentAd.desc}</p>
            <div />
            <div />
            <div />
            <Link
              href={currentAd.link || '/'}
              onClick={linkClick}
              className="hover:text-white bg-[#0c0c0c] rounded-[6px] text-white border-none flex items-center justify-center h-8 xs:h-10"
            >
              {t('Try Now')} <MoveRight className="ml-2" size={16} />
            </Link>
          </div>
        </div>
      }
    >
      <div
        className="max-w-[926px] mx-auto mt-10 bg-cover bg-no-repeat aspect-[926/276]"
        style={{ backgroundImage: `url(${currentAd.imgUrl_pc})` }}
      >
        <div className="h-full pl-[14.25%] py-[3.5%] pr-[48%] flex flex-col justify-between">
          <h3 className="text-[32px] font-bold leading-[1.4] text-white">{currentAd.title}</h3>
          <p className="text-white">{currentAd.desc}</p>
          <div />
          <div />
          <div />
          <Link
            href={currentAd.link || '/'}
            className="hover:text-white h-10 bg-[#0c0c0c] rounded-[6px] text-white border-none flex items-center justify-center max-w-[240px]"
          >
            {t('Try Now')} <MoveRight className="ml-2" size={16} />
          </Link>
        </div>
      </div>
    </Container>
  );
}
